import type { SupportPartnerDto } from '@/api/control/missionImpactAPI.schemas';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useLanguage } from '@/contexts/LanguageContext';
import { fillSupportTemplate } from '@/lib/support';

interface WranglerRequestNoteProps {
  /** The organization's partner, or null when none is assigned. */
  partner: SupportPartnerDto | null;
}

/**
 * Shown when a Data Wrangler request is chosen. With a partner, notes that services work is offered
 * to them first; without one, notes that a request can be sent whatever the balance. The hours
 * themselves (and buying more) are shown in the Data Wrangler hours card alongside the form.
 */
export function WranglerRequestNote({ partner }: WranglerRequestNoteProps) {
  const { t } = useLanguage();

  return (
    <Alert>
      <AlertDescription>
        {partner
          ? fillSupportTemplate(t.support.newTicket.wranglerPartnerNote, { name: partner.name ?? '' })
          : t.support.newTicket.wranglerHoursNote}
      </AlertDescription>
    </Alert>
  );
}
